export const getArticleSnippet = (articleBody: string): string | undefined => {
  const { body } = new DOMParser().parseFromString(articleBody, 'text/html');
  const articleSnippet = body.querySelector('p')?.innerText;
  return articleSnippet;
};
